export default __webpack_public_path__ + "static/media/manejoForestal.4789816e.jpg";